import { Component, EventEmitter, Input, NgZone, OnInit, OnChanges, Output, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs';
import { take } from 'rxjs/operators';
import { GridComponent, GridDataResult, DataStateChangeEvent } from '@progress/kendo-angular-grid';
import { process, State } from '@progress/kendo-data-query';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ApplicationControlService } from '../../services/applicationcontrol.service';
import { CSEService } from '../../services/cse.service';
import { DataService } from '../../services/data.service';
import { EmailService } from '../../services/email.service';
import { EmployeeService } from '../../services/employees.service';
import { OrderService } from '../../services/order.service';
import { NotificationService } from '../../services/notification.service';
//import { RecordLockService } from '../../services/recordlock.service';
import { UtilService} from '../../services/util.service';
import { SendEmailDialog } from '../send-email-popup/send-email-popup.component';
import {
    Employee
    , Offer
    , OpportunityCostType
    , OrderStop
    , QuoteOrderLine
    , QuoteOrderLineOpportunityCost
    , SearchOffer
    , SearchQuoteOrder
} from '../../models/models';

@Component({
    selector: 'carrier-offer-grid',
    templateUrl: './carrier-offer-grid.component.html',
    standalone: false
})
export class CarrierOfferGrid implements OnInit, OnChanges {
    @Input() quoteOrderLineID: number = 0;
    @Input() isAward: boolean = false;
    @Input() refreshDate: Date = new Date();
    @Input() viewType: string = "";
    @Output() onAwardOfferClick = new EventEmitter<any>();
    @Output() onSetContractClick = new EventEmitter<any>();
    @Output() refreshData = new EventEmitter<any>();
    @Output() onAwardRefresh = new EventEmitter<any>();

    @ViewChild(GridComponent, { static: false }) public offersGrid!: GridComponent;

    private subOffers: Subscription | undefined;

    public offerID: number = 0;
    public quoteOrderLine: QuoteOrderLine = {} as QuoteOrderLine;
    public searchQuoteOrder: SearchQuoteOrder = {} as SearchQuoteOrder;
    public orderStopList: OrderStop[] = [];
    public geocodeLaneID: number = 0;
    //public allEmployees: Employee[] = [];
    public offerListAll: SearchOffer[] = [];
    public offerList: SearchOffer[] = [];
    public isExcludeNonRMISCertified: boolean = true;
    public isShowAll: boolean = false;

    public isEditOpportunityCosts: boolean = false;
    public opportunityCostTypeList: OpportunityCostType[] = [];
    public availableOpportunityCostTypeList: OpportunityCostType[] = [];
    public quoteOrderLineOpportunityCostList: QuoteOrderLineOpportunityCost[] = [];

    //public offers: Observable<Offer[]> = new Observable<Offer[]>();

    //private recordLockAction: string = "";
    //private recordLockSource: string = "Procurement";

    public gridState: State = { skip: 0, take: 10 };
    public gridData: GridDataResult = { data: [], total: 0 };

    constructor(private applicationControlService: ApplicationControlService, private cseService: CSEService,
        private dataService: DataService, private emailService: EmailService,
        private employeeService: EmployeeService, public dialog: MatDialog, private ngZone: NgZone,
        private notificationService: NotificationService, private orderService: OrderService,
        //private recordLockService: RecordLockService,
        private utilService: UtilService) {
        //this.offerSubscription = this.cseService.getOffers().subscribe(result => {
        //    if (result) {
        //        this.offerList.push(result);
        //    }
        //    else {
        //        this.offerList = [];

        //    }
        //});
        this.applicationControlService.getApplicationControlsByAppName("IsExcludeNonRMISCertified", false).subscribe(result => {
            if (result.length > 0) {
                var appValue = result[0].appSettingValue;
                if (appValue == "1") {
                    this.isExcludeNonRMISCertified = true;
                }
                else {
                    this.isExcludeNonRMISCertified = false;
                }
            }
        });
    }

    ngOnInit() {
        //this.initValues();
        //this.getQuoteOrderLine();
        //this.cseService.getOffersByLineId(this.quoteOrderLineID);
        //this.offers = this.cseService.offers;
        //this.getAllEmployees();
        this.getOpportunityCostTypes();
        //this.initRecordLock();
        //console.log("ngOnInit", this.isAward);
    }

    ngOnChanges() {
        //this.cseService.getOffersByLineId(this.quoteOrderLineID);
        //this.offers = this.cseService.offers;
        //this.offers.subscribe(result => {
        //    this.offerList = result;
        //});
        this.getQuoteOrderLineOpportunityCostByQuoteOrderLineID();
        this.getSearchQuoteOrder();
        this.getSearchOrderStop();
        this.getOffers();
        //console.log("ngOnChanges", this.isAward);
    }

    //private getAllEmployees() {
    //    this.utilService.isLoading = true;
    //    this.employeeService.getAllEmployees().subscribe(result => {
    //        this.utilService.isLoading = false;
    //        this.allEmployees = result;
    //    });
    //}

    private getOpportunityCostTypes() {
        this.cseService.getOpportunityCostTypes().subscribe(result => {
            this.opportunityCostTypeList = result.resultCollection;
            this.opportunityCostTypeList = this.opportunityCostTypeList.filter(t => t.isRetired == false);
        });
    }

    private getQuoteOrderLineOpportunityCostByQuoteOrderLineID() {
        this.cseService.getQuoteOrderLineOpportunityCostByQuoteOrderLineID(this.quoteOrderLineID).subscribe(result => {
            this.quoteOrderLineOpportunityCostList = result.resultCollection;
        });
    }

    private getSearchQuoteOrder() {
        this.orderService.getSearchQuoteOrderLineByID(this.quoteOrderLineID).subscribe(result => {
            if (result.resultCollection.length > 0) {
                this.searchQuoteOrder = result.resultCollection[0];
            }
        });
    }

    private getSearchOrderStop() {
        this.orderService.getOrderStopsByLineId(this.quoteOrderLineID).subscribe(result => {
            this.orderStopList = result.resultCollection;
            var numUnassigned = this.orderStopList.filter(t => t.customerId <= 0).length;
            if (numUnassigned > 0) {
                this.isAward = false;
            }
        });
    }

    private getOffers() {
        //console.log("getOffers", this.offers);
        //this.offers.subscribe(result => {
        //    this.offerList = result;
        //});

        //this.cseService.getOffersByLineId(this.quoteOrderLineID).subscribe(result => {
        //    this.offerList = result;
        //    this.setOffersGrid();
        //    console.log("getOffers", this.offerList);
        //});

        this.utilService.isLoading = true;
        this.cseService.getSearchOfferByQuoteOrderLineID(this.quoteOrderLineID).subscribe(result => {
            this.utilService.isLoading = false;
            this.offerListAll = result.resultCollection;
            this.offerList = this.offerListAll.filter(o => o.offerRate > 0 || o.isDeclined == true);
            this.setOffersGrid();
            //console.log("getOffers", this.offerList);
        });

        //var name = "getOffersByLineId-" + this.quoteOrderLineID;
        //if (this.subOffers) {
        //    this.subOffers.unsubscribe();
        //}
        //var data = this.dataService.get(name);
        //if (data) {
        //    this.offerListAll = data.resultCollection;
        //    this.offerList = this.offerListAll.filter(o => o.offerRate > 0 || o.declined == true);
        //    this.setOffersGrid();
        //    //console.log("offerList", this.offerList);
        //}
        //else {
        //    this.utilService.isLoading = true;
        //    this.subOffers = this.dataService.currentDataCollection.subscribe(result => {
        //        this.utilService.isLoading = false;
        //        if (result.name == name) {
        //            this.offerListAll = result.resultCollection;
        //            this.offerList = this.offerListAll.filter(o => o.offerRate > 0 || o.declined == true);
        //            this.setOffersGrid();
        //            //console.log("offerList", this.offerList);
        //        }
        //    });
        //}
    }

    public refreshOffers() {
        this.offerListAll.length = 0;
        this.offerList.length = 0;
        //var name = "getOffersByLineId-" + this.quoteOrderLineID;
        //this.dataService.clear(name);
        //this.cseService.getOffersByLineId(this.quoteOrderLineID);
        this.refreshData.emit("carrier");
        this.getQuoteOrderLineOpportunityCostByQuoteOrderLineID();
        this.getOffers();
    }

    private fitColumns() {
        this.ngZone.onStable.asObservable().pipe(take(1)).subscribe(() => {
            if (this.offersGrid == null) return;
            //this.carriersGrid.autoFitColumns();
        });
    }

    public dataStateChange(state: DataStateChangeEvent): void {
        this.gridState = state;
        this.gridData = process(this.offerList, this.gridState);
    }

    public offersDataStateChange(state: DataStateChangeEvent): void {
        this.gridState = state;
        this.setOffersGrid();
    }

    public setOffersGrid() {
        this.gridData = process(this.offerList, this.gridState);
        this.fitColumns();
    }

    public toggleShowAll() {
        this.isShowAll = !this.isShowAll;
        if (this.isShowAll) {
            this.offerList = Object.assign([], this.offerListAll);
        }
        else {
            this.offerList = this.offerListAll.filter(o => o.offerRate > 0 || o.isDeclined == true);
        }
        this.setOffersGrid();
    }

    public awardOffer(offer: SearchOffer) {
        this.offerID = offer.offerID;
        //this.recordLockAction = "awardOffer";
        //this.recordLockService.checkHasRecordLock("QuoteOrder", this.searchQuoteOrder.quoteOrderID, this.recordLockSource);
        this.allowAwardOffer(offer);
    }

    private allowAwardOffer(offer: SearchOffer) {
        var isAwarded: boolean = false;
        this.utilService.isLoading = true;
        this.cseService.getOffersByLineIdObs(offer.quoteOrderLineID).subscribe(result => {
            this.utilService.isLoading = false;
            var offerCheckList: Offer[] = result.resultCollection;
            for (var i = 0; i < offerCheckList.length; i++) {
                if (offerCheckList[i].awarded == true) {
                    isAwarded = true;
                }
            }

            if (isAwarded) {
                this.notificationService.showError("Offer already awarded and would cause double-booking.", "WARNING: Offer Awarded");
                this.onAwardRefresh.emit();
            }
            else {
                this.onAwardOfferClick.emit(offer.offerID);
            }
        });
        //this.cseService.awardOffer(offer).subscribe(result => {
        //    offer = result;
        //});
    }

    public setContract(offer: SearchOffer) {
        this.onSetContractClick.emit(offer);
    }

    public sendOfferEmail(offer: SearchOffer) {
        var accountRep: Employee = {} as Employee;
        var opsRep: Employee = {} as Employee;
        var toEmail: string = "";

        this.cseService.getOfferByID(offer.offerID).subscribe(result => {
            //var thisOffer: Offer = result.resultCollection[0];
            if (offer.accountRepEmail != null && offer.accountRepEmail != "") {
                toEmail += offer.accountRepEmail;
            }
            if (offer.opsRepEmail != null && offer.opsRepEmail != "") {
                if (toEmail.length > 0) {
                    toEmail += ",";
                }
                toEmail += offer.opsRepEmail;
            }
            //console.log("sendOfferEmail:To", toEmail, accountRep, opsRep);

            const dialogConfig = new MatDialogConfig();
            dialogConfig.disableClose = false;
            dialogConfig.autoFocus = true;
            dialogConfig.data = {
                showEmailBody: false,
                showSubject: false,
                //contacts: contacts,
                emailTo: toEmail,
                emailCC: "",
                ccEmails: "",
                emailSubject: "",
                emailBody: ""
            }

            const dialogRef = this.dialog.open(SendEmailDialog, dialogConfig);

            //console.log("sendOfferEmail", accountRep, offer);

            dialogRef.componentInstance.emailTo = toEmail;
            dialogRef.componentInstance.emailCC = "";
            dialogRef.componentInstance.ccEmails = [];
            dialogRef.componentInstance.emailSubject = "";
            dialogRef.componentInstance.emailBody = "";
            //dialogRef.componentInstance.notes = dataItem.comment;

            dialogRef.afterClosed().subscribe(result => {
                //console.log(result);
                if (result.btnOK == true) {
                    this.utilService.isLoading = true;
                    this.emailService.sendOfferEmail(offer.offerID, result.emailTo, result.emailCC).subscribe(result => {
                        this.utilService.isLoading = false;
                        var ok = result;
                    });
                }
            });
        })
    }

    public deleteOffer(offer: SearchOffer) {
        //this.offerID = offer.offerID;
        //this.recordLockAction = "deleteOffer";
        //this.recordLockService.checkHasRecordLock("QuoteOrder", this.searchQuoteOrder.quoteOrderID, this.recordLockSource);
        this.allowDeleteOffer(offer);
    }

    public allowDeleteOffer(offer: SearchOffer) {
        this.utilService.isLoading = true;
        this.cseService.getOfferByID(offer.offerID).subscribe(result => {
            this.utilService.isLoading = false;
            var thisOffer: Offer;
            thisOffer = result.resultCollection[0];
            if (confirm("Delete this offer? : Carrier " + offer.carrierCode + " for $" + thisOffer.offerRate)) {
                this.utilService.isLoading = true;
                this.cseService.deleteOffer(thisOffer).subscribe(result => {
                    var ok = result;
                    this.utilService.isLoading = false;
                    //this.recordLockService.clearRecordLock("QuoteOrder", offer.quoteOrderID, this.recordLockSource);
                    this.refreshOffers();
                    this.refreshData.emit("carrier");
                });
            }
        });
    }

    public canEditOpportunityCosts(offerID: number) {
        var canEdit: boolean = false;
        var offerCosts = this.quoteOrderLineOpportunityCostList.filter(t => t.offerID == offerID);
        var assignedOpportunityCosts = this.quoteOrderLineOpportunityCostList.filter(t => t.isUsedForCost == true);
        if (offerCosts.length > 0) {
            canEdit = true;
        }
        else if (offerCosts.length == 0 && assignedOpportunityCosts.length < this.opportunityCostTypeList.length) {
            canEdit = true;
        }
        return canEdit;
    }

    public editOpportunityCosts(offerID: number) {
        this.isEditOpportunityCosts = true;
        this.offerID = offerID;
        this.availableOpportunityCostTypeList = [];
        for (var i = 0; i < this.opportunityCostTypeList.length; i++) {
            var idx = this.quoteOrderLineOpportunityCostList.findIndex(t => t.offerID != offerID && t.opportunityCostTypeID == this.opportunityCostTypeList[i].opportunityCostTypeID && t.isUsedForCost == true);
            if (idx < 0) {
                this.availableOpportunityCostTypeList.push(this.opportunityCostTypeList[i]);
            }
        }
        //console.log("editOpportunityCosts", offerID, this.availableOpportunityCostTypeList, this.quoteOrderLineOpportunityCostList);
    }

    public checkIsUsedForCost(opportunityCostTypeID: number) {
        var idx = this.quoteOrderLineOpportunityCostList.findIndex(t => t.offerID == this.offerID && t.opportunityCostTypeID == opportunityCostTypeID);
        var isUsedForCost: boolean = false;
        if (idx >= 0) {
            isUsedForCost = this.quoteOrderLineOpportunityCostList[idx].isUsedForCost;
        }
        //console.log("checkIsUsedForCost", this.offerID, opportunityCostTypeID, idx, isUsedForCost, this.quoteOrderLineOpportunityCostList);
        return isUsedForCost;
    }

    public setOpportunityCost(opportunityCostTypeID: number) {
        var idx = this.quoteOrderLineOpportunityCostList.findIndex(t => t.offerID == this.offerID && t.opportunityCostTypeID == opportunityCostTypeID);
        //console.log("setOpportunityCost", this.offerID, opportunityCostTypeID, idx);
        var cost: QuoteOrderLineOpportunityCost = {} as QuoteOrderLineOpportunityCost;
        if (idx < 0) {
            cost.quoteOrderLineOpportunityCostID = 0;
            cost.quoteOrderLineID = this.quoteOrderLineID;
            cost.offerID = this.offerID;
            cost.opportunityCostTypeID = opportunityCostTypeID;
            cost.isUsedForCost = true;
            cost.createdDate = new Date();
            cost.createdByEmployeeID = parseInt(localStorage.getItem('EmployeeId')!);
        }
        else {
            cost = this.quoteOrderLineOpportunityCostList[idx];
            cost.isUsedForCost = !this.quoteOrderLineOpportunityCostList[idx].isUsedForCost;
            cost.lastModifiedByEmployeeID = parseInt(localStorage.getItem('EmployeeId')!);
        }
        this.cseService.saveQuoteOrderLineOpportunityCost(cost).subscribe(result => {
            if (result.resultCollection.length > 0 && idx < 0) {
                this.quoteOrderLineOpportunityCostList.push(result.resultCollection[0]);
            }
            //console.log("setOpportunityCost", this.quoteOrderLineID, this.offerID, opportunityCostTypeID, cost, result);
        })
    }

    public cancelEdit() {
        this.isEditOpportunityCosts = false;
        this.availableOpportunityCostTypeList = [];
        this.offerID = 0;
        this.refreshOffers();
    }

    public leaveComment(offer: SearchOffer) {
        this.utilService.isLoading = true;
        this.cseService.getOfferByID(offer.offerID).subscribe(result => {
            this.utilService.isLoading = false;
            var thisOffer: Offer;
            thisOffer = result.resultCollection[0];
            thisOffer.notes = offer.commentText;
            this.cseService.saveOfferComment(thisOffer).subscribe(result => {
                var ok = result;
                this.utilService.isLoading = false;
            });
        });
    }

    //private initRecordLock() {
    //    this.recordLockService.continueRecordLockObserver.subscribe(result => {
    //        //console.log("order-form:handleRecordLock:isContinueRecorLock", this.recordLockService.isContinueRecordLock);
    //        if (this.recordLockService.isContinueRecordLock) {
    //            //this.continueRecordLockAction();
    //        }
    //    });
    //    this.recordLockService.cancelOverrideObserver.subscribe(result => {
    //        //console.log("order-form:initRecordLock:isCancelOverride", this.recordLockService.isCancelOverride);
    //        if (this.recordLockService.isCancelOverride) {
    //            this.recordLockService.isLocked = false;
    //            //this.refreshOffers();
    //        }
    //    });
    //    //this.recordLockService.timeoutRecordLockObserver.subscribe(result => {
    //    //    if (this.recordLockService.isRecordLockTimeout) {
    //    //        //console.log("tracking-dashboard:handleRecordLock:isRecordLockTimeout", this.recordLockAction, this.quoteOrderID, this.recordLockService.searchRecordLock);
    //    //        this.recordLockService.clearRecordLock("QuoteOrder", this.searchQuoteOrder.quoteOrderID, this.recordLockSource);
    //    //        //this.recordLockService.clearRecordLock(this.recordLockService.recordLock.recordLockID);
    //    //        //this.continueRecordLockAction();
    //    //    }
    //    //});
    //    //this.recordLockService.timeoutConfirmObserver.subscribe(result => {
    //    //    if (this.recordLockService.isConfirmTimeout) {
    //    //        //console.log("tracking-dashboard:handleRecordLock:timeoutConfirmObserver", this.recordLockAction, this.quoteOrderID, this.recordLockService.searchRecordLock);
    //    //        this.recordLockService.resetRecordLock();
    //    //        //this.navigateQuoteOrder(this.quoteOrderID, true);
    //    //        this.refreshOffers();
    //    //    }
    //    //});
    //    this.recordLockService.hasRecordLockObserver.subscribe(result => {
    //        //console.log("order-form:handleRecordLock:isContinueRecorLock", this.recordLockService.isContinueRecordLock);
    //        if (this.recordLockService.hasRecordLock) {
    //            if (this.recordLockAction == "awardOffer") {
    //                var offer = this.offerList.find(t => t.offerID == this.offerID);
    //                if (offer != null) {
    //                    this.allowAwardOffer(offer);
    //                }
    //            }
    //            else if (this.recordLockAction == "deleteOffer") {
    //                var offer = this.offerList.find(t => t.offerID == this.offerID);
    //                if (offer != null) {
    //                    this.allowDeleteOffer(offer);
    //                }
    //            }
    //            this.recordLockAction = "";
    //        }
    //    });
    //}

    //public cancelOverride() {
    //    if (!this.recordLockService.isLocked) {
    //        this.recordLockService.clearRecordLock("QuoteOrder", this.quoteOrderLine.quoteOrderID);
    //    }
    //}

    //private handleRecordLock(id: number) {
    //    this.recordLockService.handleRecordLock("QuoteOrder", id, "Offers Grid");
    //    this.recordLockService.continueRecordLockObserver.subscribe(result => {
    //        //console.log("order-stop-grid:handleRecordLock:isContinueRecorLock", this.recordLockService.isContinueRecordLock);
    //        if (this.recordLockService.isContinueRecordLock) {
    //            this.continueRecordLockAction();
    //        }
    //    });
    //}

    //private continueRecordLockAction() {
    //    if (!this.recordLockService.isLocked) {
    //        if (this.recordLockAction == "awardOffer") {
    //            var offer = this.offerList.find(t => t.offerID == this.offerID);
    //            if (offer != null) {
    //                this.allowAwardOffer(offer);
    //            }
    //        }
    //        else if (this.recordLockAction == "deleteOffer") {
    //            var offer = this.offerList.find(t => t.offerID == this.offerID);
    //            if (offer != null) {
    //                this.allowDeleteOffer(offer);
    //            }
    //        }
    //        this.recordLockAction = "";
    //    }
    //}
}
